<icc-list [tabs]="colorGroups" searchable="true" [items]="colors"  (select)="selectColor($event)" [itemTemplate]="'itemColor'" [selected]="selectedColorId"></icc-list>
